import React, { useState, useEffect } from 'react';


const Section2 = ({ contenuti }) => {
    const [isMobile, setIsMobile] = useState(false);
    
    
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 992); 
        };
    
        handleResize();
        window.addEventListener("resize", handleResize);
    
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);
    
  return (
    <>
      {contenuti.map((content, index) => {
        const {
          titolo1,
          titolo2,
          sottotitolo,
          descrizione,
          immaginiAggiuntive,
        } = content;
        return (
          <div
            key={index}
            className="container-fluid d-flex flex-column align-items-start position-relative"
            style={{
              padding: "32px 16px",
              gap: "16px",
            }}
          >
            <div className="container">
              <div className="row">
                <p className="mini-title">{sottotitolo}</p>
              </div>
              <div className="row w-100">
                {/* Testo Sinistro */}
                <div className="col-12 col-md-6 d-flex flex-column align-items-start">
                  
                  <div className="title-section">
                  <h2 className={`black-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`}>
                      {titolo1}
                    </h2>
                    <h2 className={`green-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`} >{titolo2}</h2>
                  </div>
                </div>

                {/* Testo Destro */}
                <div className="col-12 col-md-6 d-flex flex-column align-items-start gap-3 mt-3 mt-md-0">
                  <div />
                  <p
                    className="custom-text"
                    dangerouslySetInnerHTML={{ __html: descrizione }}
                  ></p>
                </div>
              </div>
            </div>

            {/* Image Section */}
            <div className="container mt-4">
              <div className="row g-2">
                {/* Parte sinistra: Immagini 10 e 9 in colonna, immagine 8 affiancata */}
                <div className="col-12 col-md-6">
                  <div className="row g-2">
                    {/* Immagini 10 e 9 in colonna */}
                    <div className="col-6 d-flex flex-column gap-2">
                      {immaginiAggiuntive?.slice(0, 2).map((img, index) => (
                        <img
                          key={index}
                          src={img} 
                          alt={`Image ${index + 1}`}
                          className="img-fluid"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            margin: 0,
                          }}
                        />
                      ))}
                    </div>

                    {/* Immagine 8 affiancata */}
                    <div className="col-6">
                      {immaginiAggiuntive?.[2] && (
                        <img
                          src={immaginiAggiuntive[2]} 
                          alt="Image 8"
                          className="img-fluid"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            margin: 0,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Parte destra: Immagini replicate */}
                <div className="col-12 col-md-6">
                  <div className="row g-2">
                    {/* Immagini 10 e 9 in colonna */}
                    <div className="col-6 d-flex flex-column gap-2">
                      {immaginiAggiuntive?.slice(3, 5).map((img, index) => (
                        <img
                          key={index}
                          src={img} // Usa immagine_path
                          alt={`Image ${index + 3}`}
                          className="img-fluid"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            margin: 0,
                          }}
                        />
                      ))}
                    </div>

                    {/* Immagine 8 affiancata */}
                    <div className="col-6">
                      {immaginiAggiuntive?.[4] && (
                        <img
                          src={immaginiAggiuntive[5]} 
                          alt="Image 8"
                          className="img-fluid"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            margin: 0,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Section2;